import PageCommingSoon from "./page-comming-soon";

export default PageCommingSoon;